module.exports = __webpack_public_path__ + "static/hire.bg-d30966df8212bf693cf329e10285a3f8.png";